import React, { useState, useEffect } from 'react';
import API from '../../api/axios';
import { formatCreatedAt } from '../../utils/dateUtils';

const AdminPayments = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, totalPages: 1 });
  const [statusFilter, setStatusFilter] = useState('');
  const [providerFilter, setProviderFilter] = useState('');

  const fetchPayments = async (page = 1) => {
    setLoading(true);
    try {
      const params = { page, limit: 15 };
      if (statusFilter) params.status = statusFilter;
      if (providerFilter) params.provider = providerFilter;
      const res = await API.get('/admin/payments', { params });
      setPayments(res.data.data.payments);
      setPagination({ page: res.data.data.pagination.page, totalPages: res.data.data.pagination.totalPages });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayments();
  }, [statusFilter, providerFilter]);

  const getStatusBadge = (status) => {
    const map = { initiated: 'Initié', pending: 'En cours', success: 'Réussi', failed: 'Échoué', cancelled: 'Annulé' };
    return <span className={`badge badge-${status}`}>{map[status] || status}</span>;
  };

  const providerNames = {
    mpesa: 'M-Pesa', orange_money: 'Orange Money',
    airtel_money: 'Airtel Money', afrimoney: 'Afrimoney',
  };

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 22, fontWeight: 600 }}>Suivi des paiements</h2>
        <p style={{ color: 'var(--gray-500)', fontSize: 14 }}>Tous les paiements Mobile Money reçus</p>
      </div>

      <div className="card" style={{ marginBottom: 20 }}>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
          <select className="form-select" style={{ width: 160 }} value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}>
            <option value="">Tous statuts</option>
            <option value="success">Réussi</option>
            <option value="pending">En cours</option>
            <option value="failed">Échoué</option>
            <option value="initiated">Initié</option>
          </select>
          <select className="form-select" style={{ width: 180 }} value={providerFilter}
            onChange={(e) => setProviderFilter(e.target.value)}>
            <option value="">Tous opérateurs</option>
            <option value="mpesa">M-Pesa</option>
            <option value="orange_money">Orange Money</option>
            <option value="airtel_money">Airtel Money</option>
            <option value="afrimoney">Afrimoney</option>
          </select>
        </div>
      </div>

      <div className="card">
        {loading ? (
          <div className="loading-page"><div className="spinner"></div></div>
        ) : payments.length === 0 ? (
          <div className="empty-state"><h3>Aucun paiement</h3></div>
        ) : (
          <>
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Référence</th>
                    <th>Patient</th>
                    <th>Facture</th>
                    <th>Montant</th>
                    <th>Opérateur</th>
                    <th>Téléphone</th>
                    <th>Statut</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {payments.map((p) => (
                    <tr key={p.id}>
                      <td style={{ fontWeight: 600, fontSize: 13 }}>{p.payment_reference}</td>
                      <td>{p.patient?.first_name} {p.patient?.last_name}</td>
                      <td>
                        <span style={{ fontSize: 13 }}>{p.invoice?.invoice_number}</span>
                        <br /><span style={{ fontSize: 12, color: 'var(--gray-500)' }}>{p.invoice?.motif}</span>
                      </td>
                      <td style={{ fontWeight: 600 }}>{parseFloat(p.amount).toLocaleString()} {p.currency}</td>
                      <td>{providerNames[p.provider] || p.provider}</td>
                      <td>{p.phone_number}</td>
                      <td>{getStatusBadge(p.status)}</td>
                      <td>{formatCreatedAt(p)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {pagination.totalPages > 1 && (
              <div className="pagination">
                <button disabled={pagination.page <= 1} onClick={() => fetchPayments(pagination.page - 1)}>Précédent</button>
                <span style={{ fontSize: 14, color: 'var(--gray-600)' }}>Page {pagination.page} / {pagination.totalPages}</span>
                <button disabled={pagination.page >= pagination.totalPages} onClick={() => fetchPayments(pagination.page + 1)}>Suivant</button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default AdminPayments;
